import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import CardItem from './components/CardItem';

const Panel = (props) => {
  return (
    <Container fluid>
      <Row>
        <Col
          className="pb-2"
          sm="6"
          md="6"
          lg="3"
          xl="3"
        >
          <CardItem
            variant="secondary"
            title="Columas de facturas"
            icon={['fas', 'list']}
            to="/cuenta/panel-configuraciones/columnas-facturas"
            text="dark"
            bg=""
          />
        </Col>

        <Col
          className="pb-2"
          sm="6"
          md="6"
          lg="3"
          xl="3"
        ></Col>

        <Col
          className="pb-2"
          sm="6"
          md="6"
          lg="3"
          xl="3"
        ></Col>

        <Col
          className="pb-2"
          sm="6"
          md="6"
          lg="3"
          xl="3"
        ></Col>
      </Row>
    </Container>
  );
};

export default Panel;
